
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7eff1d85ccfd212616d3a075f242bf4aen from './en.yaml'
            i18n.addResourceBundle('en', '7eff1d85ccfd212616d3a075f242bf4a', flattenObject(ns7eff1d85ccfd212616d3a075f242bf4aen), true, true);
        
        export default '7eff1d85ccfd212616d3a075f242bf4a';
    